import axios from "./axiosConfig";

export interface HhDataChartDataOptions {
  fileGuids?: string[];
  tempFileGuids?: string[];
  includeFullRange?: boolean;
}

export default async function postHhDataChartData(
  authToken: string,
  dataType: string,
  options: HhDataChartDataOptions
): Promise<any> {
  const response = await axios.post(
    `/hh_data/chart_data/${dataType}`,
    options,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return response.data;
}
